<script setup lang="ts">
import { computed } from 'vue'
import { router } from '../core/router'
import UiIcon from './UiIcon.vue'

const returnPath = computed(() =>
  router.current.worldId
    ? `/world/${router.current.worldId}/dashboard`
    : '/worlds',
)
</script>

<template>
  <section class="feature-unavailable-wrap">
    <article class="panel feature-unavailable-card" role="status">
      <span class="feature-unavailable-icon" aria-hidden="true"
        ><UiIcon name="info"
      /></span>
      <div>
        <p class="eyebrow">Diese Welt</p>
        <h1>Funktion nicht verfügbar</h1>
        <p>Diese Funktion ist in den Regeln der aktuellen Welt deaktiviert.</p>
        <a class="button primary" :href="returnPath" data-router-link>
          {{
            router.current.worldId ? 'Zur Reichsübersicht' : 'Zur Weltenauswahl'
          }}
        </a>
      </div>
    </article>
  </section>
</template>
